export const CATEGORY_TYPE = {
  KUDO: 'kudo',
  COACHING: 'coaching',
  FEEDBACK: 'feedback',
  THANKYOU: 'thank-you',
  WELCOME: 'welcome'
}

export const KUDO_TYPE = {
  EXPERTISE: 1,
  BEHAVIORS: 2
}

export const KUDO_SELECT_TYPE = {
  ALL: 'all',
  RECEIVED: 'received',
  EXPERTISE: 'expertise',
  BEHAVIORS: 'behaviors'
}

export const RECEIVER_TYPE = {
  USER: 'user',
  TEAM: 'team'
}

export const PRONOUN_TYPE = {
  HE_HIS: 1,
  SHE_HER: 2,
  THEY_THEM: 3
}

export const FEEDBACK_TYPE = {
  MANAGER: 'manager',
  PEER: 'peer',
  EXTERNAL: 'external',
  TEAM: 'team'
}

export const SIGNUP_STEP_TYPE = {
  IDENTITY: 'identity',
  ABOUTYOU: 'aboutyou',
  CONTACT: 'contact',
  TEAM: 'team',
  INVITATIONS: 'invitations'
}
